import SpecialtyForm from './SpecialtyForm';
export default SpecialtyForm;